import { useState } from 'react';
import { useNotify } from 'react-admin';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { goApi } from '../../services';
import { apiRoutes } from '../../services/apiRoutes';

const DeleteAssignedUserButton = ({ type, typeId, userId, record, onSuccess }: any) => {
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const notify = useNotify();

    if (!record) return null;

    const handleClick = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleConfirm = async () => {
        setIsLoading(true);
        try {
            await goApi.delete(apiRoutes.DELETE_ASSIGNED_USERS(type, typeId, userId));
            notify('User removed successfully', { type: 'success' });
            handleClose();
            if (onSuccess) {
                onSuccess();
            }
        } catch (error: any) {
            notify(error?.message || 'Error while deleting user', { type: 'error' });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Button
                color="error"
                startIcon={<DeleteIcon />}
                onClick={handleClick}
                disabled={isLoading}
            >
                Delete
            </Button>

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete{' '}
                        <strong>{record?.name || 'this item'}</strong>? This action cannot be
                        undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleConfirm} color="error" disabled={isLoading}>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default DeleteAssignedUserButton;
